import { render, staticRenderFns } from "./BillOfMaterial.vue?vue&type=template&id=8b65524c"
import script from "./BillOfMaterial.vue?vue&type=script&lang=js"
export * from "./BillOfMaterial.vue?vue&type=script&lang=js"
import style0 from "./BillOfMaterial.vue?vue&type=style&index=0&id=8b65524c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports